import { STEPS } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "./SectionHeading";

export default function Steps() {
  return (
    <section id="steps" className="relative scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <SectionHeading
            kicker="三步上手开吃"
            title={
              <>
                零门槛，<span className="text-primary-600">三秒进现场</span>
              </>
            }
            desc="不用下载、不用注册缴费，打开网页就能围观互动，跟着下面三步就能从围观变成主角。"
          />
        </Reveal>

        <div className="relative mt-14 grid grid-cols-1 gap-8 md:grid-cols-3">
          <div className="pointer-events-none absolute left-[16%] right-[16%] top-10 hidden border-t-2 border-dashed border-primary-200 md:block"></div>
          {STEPS.map((s, idx) => (
            <Reveal key={s.step} delay={idx * 100}>
              <div className="relative text-center">
                <div className="relative mx-auto flex h-20 w-20 items-center justify-center rounded-3xl bg-gradient-to-br from-primary-500 to-accent-500 text-background-50">
                  <i className={`${s.icon} text-3xl`} />
                  <span className="absolute -right-2 -top-2 flex h-8 w-8 items-center justify-center rounded-full bg-secondary-600 text-xs font-bold text-background-50 ring-4 ring-background-50">
                    {s.step}
                  </span>
                </div>
                <h3 className="mt-5 text-lg font-bold text-foreground-950">{s.title}</h3>
                <p className="mx-auto mt-2 max-w-xs text-sm leading-6 text-foreground-600">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-12 text-center">
            <a
              href="#join"
              className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-8 py-4 text-base font-bold text-foreground-950 transition hover:bg-primary-600 whitespace-nowrap"
            >
              <i className="ri-rocket-2-fill text-lg" />
              现在就去吃瓜现场
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}